var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 7.16671H2M10.6667 1.83337V4.50004M5.33333 1.83337V4.50004M5.2 15.1667H10.8C11.9201 15.1667 12.4802 15.1667 12.908 14.9487C13.2843 14.757 13.5903 14.451 13.782 14.0747C14 13.6469 14 13.0868 14 11.9667V6.36671C14 5.2466 14 4.68655 13.782 4.25873C13.5903 3.8824 13.2843 3.57644 12.908 3.38469C12.4802 3.16671 11.9201 3.16671 10.8 3.16671H5.2C4.0799 3.16671 3.51984 3.16671 3.09202 3.38469C2.71569 3.57644 2.40973 3.8824 2.21799 4.25873C2 4.68655 2 5.2466 2 6.36671V11.9667C2 13.0868 2 13.6469 2.21799 14.0747C2.40973 14.451 2.71569 14.757 3.09202 14.9487C3.51984 15.1667 4.0799 15.1667 5.2 15.1667Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarIcon);
export default __webpack_public_path__ + "static/media/CalendarIcon.d7c07afed58b95101b7026e7cc9e7482.svg";
export { ForwardRef as ReactComponent };